import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function GTMTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page: location.pathname,
    });
  }, [location]);

  return null;
}
export default GTMTracker;
